import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Typography
} from '@mui/material';

class RegisteredDialog extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      form_button: {
        margin: 2,
        borderRadius: 2,
        height:50,
        width: 170,
        boxShadow: 5
      }
    };
    this.openDialog = this.openDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
  }

  openDialog() {
    this.setState({ open: true });
  }

  closeDialog() {
    this.setState({ open: false });
  }

  render() {
    return(
    	<>
        <Dialog
          open={ this.state.open }
          onClose={ (e) => this.closeDialog() }
          aria-labelledby='dialog-title'
          aria-describedby='dialog-body'
          scroll='paper'
          PaperProps={{
            sx: {
              height: '30%',
              width: '80%'
            }
          }}
        >
          <DialogContent>
            <Typography variant='registered_body'>
              <center>
                登録が完了しました<br/>
                ご回答いただきありがとうございます
              </center>
            </Typography>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }} sx={{ mb: 2 }}>
            <Button
              variant='form_forward_button'
              size='large'
              onClick={ () => this.closeDialog() }
              sx={{
                mx: this.state.form_button.margin,
                borderRadius: this.state.form_button.borderRadius,
                height: this.state.form_button.height,
                width: this.state.form_button.width,
                boxShadow: this.state.form_button.boxShadow
              }}
            >
              閉じる
            </Button>
          </DialogActions>
        </Dialog>
			</>
    );
  };
}

export default RegisteredDialog;